import React, { Fragment } from 'react';
import { Space } from '@gr-monorepo/common/ui';
import { PlateTemplate } from './PlateTemplate';
import { useOlympiadStore } from 'features/olympiads/useOlympiadStore';
import OlympRatings from './OlympRatings';
import LoaderComponent from 'features/shared/Loader';
import { Error } from './Error';

const colors = ['#8BACFF', '#93D4FF'];

export const Olympiads = () => {
  const { currentOlympList } = useOlympiadStore();
  const olymps = currentOlympList.olympiads.slice(0, 2);
  if (currentOlympList.pending) {
    return (
      <PlateTemplate title="Олимпиады проходят сейчас" dataQaId="olympiads_block" link="/olympiads" name="olympiads">
        <LoaderComponent color={'#825AF7'} />{' '}
      </PlateTemplate>
    );
  }
  if (currentOlympList.error) {
    return (
      <PlateTemplate title="Олимпиады проходят сейчас" dataQaId="olympiads_block" link="/olympiads" name="olympiads">
        <Error />
        <Space size={200} axis="vertical" />
      </PlateTemplate>
    );
  }
  return (
    <PlateTemplate title="Олимпиады проходят сейчас" dataQaId="olympiads_block" link="/olympiads" name="olympiads">
      <Space size={24} axis="vertical" />
      {olymps.length === 0 && (
        <div style={{ lineHeight: '22px' }}>
          Нет олимпиад для прохождения сейчас. В разделе вы можете посмотреть расписание будущих олимпиад, а также
          статистику прошедших.
        </div>
      )}
      {olymps.map((el, i) => (
        <Fragment key={el.id}>
          <OlympRatings data={el} color={colors[i]} />
          <Space size={24} axis="vertical" />
        </Fragment>
      ))}
    </PlateTemplate>
  );
};
